// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__27vAd","header":"PatientQuestionnaire_header__3wNhy","info":"PatientQuestionnaire_info__3adID"};